import UpdateRelatedProtocols from './UpdateRelatedProtocols'
import store from '@/store/store.js'
import router from '@/router/router.js'

const obj = {}

obj.install = function (Vue) {
    // 1.创建组件构造器
    const Construct = Vue.extend(UpdateRelatedProtocols)

    // 2.用new 的方式用组件构造器创建出来组件对象
    const updateRelatedProtocols = new Construct({ router, store })

    // 3.将组件对象手动挂载到某一个元素上
    updateRelatedProtocols.$mount(document.createElement('div'))

    // 4.updateRelatedProtocols.$el对应的就是div
    document.body.appendChild(updateRelatedProtocols.$el)

    // 5.在原型中加入Update
    Vue.prototype.$UpdateRelatedProtocols = updateRelatedProtocols
}

export default obj
